import { Flex, Tag, Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"

import InfoTooltip from "../../../../../../../Components/InfoTooltip/InfoTooltip"
import { formatCurrency } from "../../../../../../../Utils/utils"
import { RECOMMENDATION_HINT, RECOMMENDATION_META } from "../../../constants/recommendation"

import groupStyles from "../../group.module.less"
import styles from "../detailsTab.module.less"

const { Text } = Typography

// Fight / refund / accept, from the backend decision engine.
const RecommendationBlock = ({ recommendation }) => {
  const { t } = useTranslation()
  const meta = RECOMMENDATION_META[recommendation.action]

  return (
    <div className={cls(groupStyles.groupCard, groupStyles.groupCardSpaced)}>
      <div className={groupStyles.groupLabel}>
        {t("Recommended action")}
        <InfoTooltip
          title={t(
            "Our suggested next step, weighing the amount and the recovery economics (you owe a commission only on a win). Fight, refund, or accept."
          )}
        />
      </div>
      <Flex align="center" gap={8} wrap="wrap">
        <Tag color={meta?.color || "default"}>{t(meta?.label || recommendation.action)}</Tag>
        {recommendation.expected_value != null ? (
          <Text type="secondary">
            {t("Expected recovery _v_", { v: formatCurrency(recommendation.expected_value) })}
          </Text>
        ) : null}
      </Flex>
      {RECOMMENDATION_HINT[recommendation.reason] ? (
        <Text type="secondary" className={styles.hint}>
          {t(RECOMMENDATION_HINT[recommendation.reason])}
        </Text>
      ) : null}
    </div>
  )
}

export default RecommendationBlock
